import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AGB: React.FC = () => {
  useEffect(() => {
    // Add meta robots tag to prevent indexing
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    // Clean up function to remove the meta tag when component unmounts
    return () => {
      const existingTag = document.querySelector('meta[name="robots"]');
      if (existingTag) {
        document.head.removeChild(existingTag);
      }
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h1 className="text-2xl font-bold text-deep-blue mb-6">Allgemeine Geschäftsbedingungen für die Plattform Adressfinder.org ("Allgemeine Geschäftsbedingungen")</h1>
          <p className="text-left text-sm text-gray-600 mb-6">(Stand 16.01.2026)</p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">1. Geltungsbereich der Allgemeinen Geschäftsbedingungen</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">1.1.</span>
                <div className="flex-1">
                  Die YN Digital GmbH, Am Schulhof 23, 28865 Lilienthal (nachfolgend: YN Digital) bietet unter der Website AdressFinder.org eine Plattform an, über die Verbraucher (§ 13 BGB) und – im Einzelfall auch- Unternehmer (§ 14 BGB), (nachfolgend jeweils Antragsteller) schnell und einfach - kostenpflichtig - die aktuelle Meldeanschrift einer gesuchten natürlichen Person in Deutschland recherchieren können (nachfolgend: Plattform).
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">1.2.</span>
                <div className="flex-1">
                  Für die Nutzung der Plattform durch Vertragspartner von YN Digital (nachfolgend: Kunden) gelten ausschließlich die nachfolgenden Allgemeinen Geschäftsbedingungen. YN Digital widerspricht ausdrücklich der Einbeziehung Allgemeiner Geschäftsbedingungen des Kunden.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">1.3.</span>
                <div className="flex-1">
                  Sofern nicht anders schriftlich vereinbart, gelten diese Allgemeinen Geschäftsbedingungen in der zum Zeitpunkt des Vertragsschlusses gültigen Fassung für die gesamte Vertragslaufzeit.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">2. Vertragsgegenstand und Leistungen</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">2.1.</span>
                <div className="flex-1">
                  Gegenstand des Vertrags ist die Bereitstellung der über die Plattform zur Verfügung gestellten Leistungen, insbesondere die Anfrage über Statusmeldungen und Melderegisterdaten aus verschiedenen deutschen Melderegistern (Melderegisterbehörden) im Rahmen des anwendbaren gesetzlichen Umfangs für Verbraucher (§ 13 BGB) und Unternehmer (§ 14 BGB). Typische Anwendungsfälle sind insbesondere das Wiederfinden von alten Bekannten, die Kontaktaufnahme mit Familienangehörigen, die Verifizierung von Wohnsitzen oder das Auffinden von Schuldnern im Rahmen der anwendbaren Gesetze. Der Umfang der Auskunft richtet sich insbesondere nach den §§ 44 ff. Bundesmeldegesetz (BMG). Vornehmlich soll für Kunden durch YN Digital eine einfache Meldeauskunft beantragt werden. Die Erbringung der Leistung, insbesondere die Weiterleitung der Anfrage an das Melderegister, setzt eine erfolgreiche Identitätsverifikation des Kunden voraus. Die Identitätsverifikation ist fester Bestandteil der vertraglich geschuldeten Dienstleistung.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">2.2.</span>
                <div className="flex-1">
                  Es besteht keine Erfolgsgarantie für die Beantwortung der jeweiligen Anfrage dahingehend, dass tatsächlich eine gewünschte Adresse ermittelt wird. Das Ergebnis einer Anfrage hängt von den gesetzlichen Voraussetzungen ab und kann insbesondere lauten: aktuelle Anschrift, keine Daten auffindbar, Auskunftssperre, unbekannt verzogen oder ähnliche amtliche Vermerke. Falls die Behörde keine Auskunft erteilt, unzureichende Daten vorliegen oder eine Auskunftssperre existiert, kann kein Ergebnis an den Kunden bereitgestellt werden. Die Vergütungspflicht entsteht unabhängig vom Ergebnis der übermittelten Abfrage und bleibt insbesondere auch erhalten, wenn die Auskunft nicht erteilt werden kann.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">2.3.</span>
                <div className="flex-1">
                  Die Bearbeitungszeit hängt von den internen Prozessen der jeweiligen Melderegisterstellen, auf die YN Digital keinen Einfluss hat.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">2.4.</span>
                <div className="flex-1">
                  Weitere Leistungen müssen ausdrücklich vereinbart werden (z.B. wird in der Regel keine "Adresskettenverfolgung" über mehrere Wohnsitze hinweg erbracht).
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">2.5.</span>
                <div className="flex-1">
                  Eine Verfügbarkeit der Plattform wird nicht garantiert. Der Plattformbetrieb selbst (Accounterstellung ohne zusätzliche kostenpflichtige Leistungen) ist kostenfrei.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">2.6.</span>
                <div className="flex-1">
                  Für die Erbringung der Leistungen, vornehmlich der Abfrage der Melderegisterdaten bei den verschiedenen Melderegistern, bedient sich die Plattform Technologien und Schnittstellen (APIs) von Drittanbietern (insbesondere Abruf/Abgleich der Meldedaten bei den Melderegistern sowie eine etwaig erforderliche Identifikation der Kunden). Soweit dies datenschutzrechtlich erforderlich ist, hat YN Digital einen entsprechenden Auftragsverarbeitungsvertrag mit diesen Drittdienstleistern geschlossen.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">3. Registrierung, Vertragsschluss und Abfrage von Melderegisterdaten</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">3.1.</span>
                <div className="flex-1">
                  Der Kunde kann einen kostenpflichtigen Vertrag über die Abfrage von Melderegisterdaten bei unterschiedlichen Melderegistern gemäß den zum Zeitpunkt des Vertragsschlusses geltenden Bedingungen der Preis- und Leistungsübersicht auf der Website von YN Digital abschließen. Die Informationen auf der Website stellen dabei lediglich eine sog. Invitatio ad offerendum und kein verbindliches Angebot dar. Der Kunde stellt ein verbindliches Angebot erst durch Klicken auf die Schaltfläche "Zahlungspflichtig bestellen". Dieses nimmt YN Digital wiederum erst durch Versand einer ausdrücklichen Annahmeerklärung in Textform bzw. Leistungserbringung der geschuldeten Leistung an.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.2.</span>
                <div className="flex-1">
                  Der Vertrag kommt mit der Bestätigung durch YN Digital zustande. Die eigentliche Durchführung der Melderegisterauskunft (Weiterleitung der Anfrage an die Behörde) erfolgt jedoch erst, nachdem der Kunde den nachgelagerten Prozess zur Identitätsverifikation erfolgreich durchlaufen hat. Hierzu erhält der Kunde nach Vertragsschluss und Zahlung eine gesonderte E-Mail mit einem Link zur Durchführung der Verifikation.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.3.</span>
                <div className="flex-1">
                  Der Vertragsschluss erfolgt in deutscher Sprache.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.4.</span>
                <div className="flex-1">
                  Verbraucher gem. § 13 BGB müssen mindestens 18 Jahre alt sein, um die Plattform nutzen zu können.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.5.</span>
                <div className="flex-1">
                  Unternehmer bestätigen, dass sie in Ausübung ihrer gewerblichen Tätigkeit handeln. Sofern gewerbliche Zwecke beabsichtigt sind, sind diese Zwecke bei der jeweiligen Abfrage anzugeben.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.6.</span>
                <div className="flex-1">
                  Kunden müssen vor der Abfrage von Melderegisterdaten erklären, dass sie Abfragen über die Plattform nicht für Zwecke der Werbung oder des Adresshandels verwenden werden.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.7.</span>
                <div className="flex-1">
                  Der Kunde kann sich zunächst registrieren und einen persönlichen Account erstellen oder kostenpflichtige Einzelleistungen über einen Gastzugang abrufen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.8.</span>
                <div className="flex-1">
                  Die Erstellung eines Accounts für die Registrierung ist kostenlos. Der Kunde ist verpflichtet, bei Erstellung des Accounts bzw. im Rahmen des kostenpflichtigen Einzelabrufs alle als erforderlich gekennzeichneten Informationen inklusive seiner E-Mail-Adresse vollständig und wahrheitsgemäß anzugeben und bei der Accounterstellung zusätzlich ein den genannten Anforderungen entsprechendes Passwort zu vergeben. Nach Angabe aller erfragten Daten durch den Kunden überprüft YN Digital diese auf Vollständigkeit und Plausibilität. Sind die Angaben aus Sicht von YN Digital vollständig und plausibel, sendet YN Digital eine E-Mail mit einem Bestätigungslink an die angegebene E-Mail-Adresse. YN Digital weist in der E-Mail darauf hin, dass der Account erst mit dem Klick auf den Bestätigungslink erstellt wird.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.9.</span>
                <div className="flex-1">
                  Nach Aktivierung des persönlichen Accounts kann der Kunde in seinem Account kostenpflichtige Leistungen zur Nutzung der Plattform abrufen und seinen persönlichen Account verwalten.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.10.</span>
                <div className="flex-1">
                  Der Kunde ist verpflichtet, den jeweils vereinbarten Preis gemäß der zum Zeitpunkt des Vertragsschlusses gültigen Preis- und Leistungsübersicht zu zahlen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.11.</span>
                <div className="flex-1">
                  Kostenpflichtige Einzelleistungen per Gastzugang werden erst nach vollständiger Bezahlung gemäß der zum Zeitpunkt des Vertragsschlusses gültigen Preis- und Leistungsübersicht zur Verfügung gestellt.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.12.</span>
                <div className="flex-1">
                  Vor Vertragsschluss stellt YN Digital diese Allgemeinen Geschäftsbedingungen zur Verfügung und zeigt an, welche Zahlungsmittel akzeptiert werden. Für diese Zahlungsmittel werden Drittanbieter eingesetzt. In diesem Fall gelten zusätzlich eigene AGB/Allgemeine Geschäftsbedingungen dieser Anbieter, auf die YN Digital keinen Einfluss hat.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.13.</span>
                <div className="flex-1">
                  Der Kunde wählt die gewünschte Leistung gemäß der Preis- und Leistungsübersicht aus und gibt die weiteren als erforderlich gekennzeichneten Informationen ein. Bevor der Kunde auf die Schaltfläche "Zahlungspflichtig bestellen" klicken kann, werden ihm seine eingegebenen Informationen und weitere gesetzlich erforderliche Informationen wie die Preisübersicht übersichtlich angezeigt und der Kunde kann Fehleingaben korrigieren. Nach dem Klick auf die Schaltfläche "Zahlungspflichtig bestellen" übersendet YN Digital eine unverbindliche Bestätigung der Bestellung sowie eine separate verbindliche Annahme des Angebots zum Vertragsschluss. Der Kunde kann die Bestellübersicht inkl. der gültigen Preis- und Leistungsübersicht, diese Allgemeinen Geschäftsbedingungen und, sofern vorhanden, weitere Dokumente des Vertragstextes jederzeit in seinem Account abrufen und herunterladen, sofern er diesen angelegt hat. Bei Einzelabruf wurden ihm diese zuvor zur Verfügung gestellt.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">3.14.</span>
                <div className="flex-1">
                  YN Digital kann eine Registrierung ablehnen oder Nutzerkonten sperren, wenn es Anhaltspunkte für eine missbräuchliche Nutzung gibt oder Verstöße gegen diese Allgemeinen Geschäftsbedingungen vorliegen.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">4. Nutzungsrechte des Kunden</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">4.1.</span>
                <div className="flex-1">
                  YN Digital (oder sein Lizenzgeber) behält sich alle Rechte an der Plattform vor, die nicht ausdrücklich den Kunden durch diese Allgemeinen Geschäftsbedingungen gewährt werden.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">4.2.</span>
                <div className="flex-1">
                  Der Kunde erhält zur Erfüllung der gemäß Preis- und Leistungsübersicht auf der Website ein nicht ausschließliches, nicht übertragbares und nicht unterlizenzierbares Recht, die Plattform im Rahmen der Allgemeinen Geschäftsbedingungen zu nutzen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">4.3.</span>
                <div className="flex-1">
                  YN Digital ist berechtigt, nach eigenem Ermessen neue und aktualisierte Versionen der Leistungen auf der Plattform bereitzustellen ("Updates"). YN Digital bietet dem Kunden die Software stets in der aktuellen Version an.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">4.4.</span>
                <div className="flex-1">
                  Teile der Software können Open-Source-Software oder Drittsoftware beinhalten. Im Falle eines Konflikts zwischen den Regelungen dieser AGB und den Lizenzen, die für die Open-Source-Software oder Drittsoftware gelten, haben diese Open-Source-Software- oder Drittsoftware-Lizenzen stets Vorrang in Bezug auf die Leistungen (oder Teile davon), die Gegenstand dieser Open-Source-Software- oder Drittsoftware-Lizenzen sind.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">5. Weitere Pflichten des Kunden</h2>
            <ol className="list-none pl-6 space-y-3">
              <div className="border-2 border-black p-4 mb-4">
                <li className="flex">
                  <strong className="mr-2">5.1.</strong>
                  <div className="flex-1">
                    <strong>Der Kunde versichert, an den durch YN Digital bereitgestellten Daten ein rechtliches Interesse zu haben, das sich insbesondere aus der Notwendigkeit zur Geltendmachung von Rechtsansprüchen ergeben kann und das ohne die Bereitstellung gefährdet wäre. Der Kunde versichert geprüft zu haben, dass berechtigte Interessen entgegenstehende Interessen der betroffenen Person nicht bestehen bzw. nicht überwiegen.</strong>
                  </div>
                </li>
                <li className="flex mt-3">
                  <strong className="mr-2">5.2.</strong>
                  <div className="flex-1">
                    <strong>Der Kunde versichert, berechtigt zu sein, an den Auftragnehmer YN Digital übermittelte und von diesem übermittelte personenbezogenen Daten zu verarbeiten. Er verpflichtet sich, diese personenbezogenen Daten gemäß gesetzlichen Bestimmungen zu behandeln und insbesondere nicht für Adresshandel oder Direktwerbung zu verwenden.</strong>
                  </div>
                </li>
              </div>
              <li className="flex">
                <span className="font-medium mr-2">5.3.</span>
                <div className="flex-1">
                  Kunden dürfen die Plattform ausschließlich zu rechtmäßigen, eigenen Zwecken nutzen. Insbesondere ist die Nutzung der Plattform zur Begehung von Straftaten, Ordnungswidrigkeiten oder der unbefugten Datenabfrage untersagt. Zudem dürfen die erhaltenen Daten nicht zu Zwecken des Adresshandels oder der Werbung verwendet werden. Darüber hinaus dürfen erhaltene Daten nicht unbefugten Dritten zur Verfügung gestellt oder öffentlich zugänglich gemacht werden.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">5.4.</span>
                <div className="flex-1">
                  Im Rahmen der gesetzlichen Voraussetzungen, insbesondere des Bundesmeldegesetzes, oder aus Sicherheitsgründen können weitere Eingaben des Kunden erforderlich sein. Die Durchführung der Melderegisterauskunft setzt eine erfolgreiche Identitätsverifikation des Kunden voraus. Der Kunde ist verpflichtet, nach Beauftragung und Bezahlung die von YN Digital per E-Mail angeforderte Identitätsverifikation unverzüglich durchzuführen. Kommt der Kunde dieser Mitwirkungspflicht nicht nach, kann YN Digital die geschuldete Leistung (Anfrage beim Melderegister) nicht erbringen. Das Risiko der Nichterbringbarkeit aufgrund fehlender Identifikation trägt in diesem Fall der Kunde.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">5.5.</span>
                <div className="flex-1">
                  Unternehmer gem. § 14 BGB müssen sicherstellen, dass sie Anfragen nur im Rahmen der anwendbaren Datenschutz- und Meldegesetze stellen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">5.6.</span>
                <div className="flex-1">
                  Der Kunde hat (i) die ihm für die Zwecke des Vertrages zugewiesenen Nutzungs- und Zugriffsberechtigungen geheim zu halten und vor dem Zugriff unbefugter Dritter zu schützen; (ii) den Plattformbetrieb nicht zu stören oder stören zu lassen und es zu unterlassen, unbefugt in Datennetze von YN Digital einzudringen oder solche Bemühungen zu fördern; und (iii) keine Viren oder sonstige Schadsoftware oder -anweisungen in den Plattformbetrieb einzuführen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">5.7.</span>
                <div className="flex-1">
                  Der Kunde verpflichtet sich, jede Form des Dekompilierens, Disassemblierens oder sonstige Form des Reverse-Engineerings zu unterlassen, die nicht bereits gesetzlich erlaubt ist.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">6. Gewährleistung</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">6.1.</span>
                <div className="flex-1">
                  YN Digital übernimmt keine Garantie für die Richtigkeit, Vollständigkeit und Aktualität der gelieferten Daten, da diese Informationen aus externen behördlichen Quellen stammen, auf deren Zurverfügungstellung YN Digital keinen Einfluss hat.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">6.2.</span>
                <div className="flex-1">
                  Ist der Kunde Verbraucher im Sinne von § 13 BGB, stehen dem Kunden die gesetzlichen Gewährleistungsrechte zu.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">6.3.</span>
                <div className="flex-1">
                  Ist der Kunde Unternehmer im Sinne des § 14 BGB, übernimmt YN Digital die Nacherfüllung bei einem Mangel der auf der Plattform zur Verfügung gestellten Leistungen nur im folgenden Umfang:
                  <ol className="list-none pl-6 space-y-3 mt-3">
                    <li className="flex">
                      <span className="font-medium mr-2">6.3.1.</span>
                      <div className="flex-1">
                        YN Digital stellt nach eigener Wahl einen verbesserten oder neuen Dienst innerhalb einer angemessenen Frist bereit.
                      </div>
                    </li>
                    <li className="flex">
                      <span className="font-medium mr-2">6.3.2.</span>
                      <div className="flex-1">
                        Wenn YN Digital proprietäre Software von Dritten verwendet, für die YN Digital Nutzungsrechte erhalten hat, gilt die Beschaffung von öffentlich verfügbaren Upgrades, Updates oder Patches als ausreichend.
                      </div>
                    </li>
                  </ol>
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">6.4.</span>
                <div className="flex-1">
                  Ist der Kunde Unternehmer im Sinne des § 14 BGB, sind unmittelbare Minderungen der Zahlungspflicht des Kunden im Falle eines Mangels, unter anderem gemäß § 536 Abs. 1 BGB, ausgeschlossen. Bereicherungsrechtliche Ansprüche aus § 812 BGB bleiben unberührt.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">6.5.</span>
                <div className="flex-1">
                  Der Kunde hat YN Digital über auftretende Mängel unverzüglich und möglichst detailliert in Textform zu informieren.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">7. Haftungsbeschränkung</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">7.1.</span>
                <div className="flex-1">
                  Bei kostenlosen Diensten haftet YN Digital nur für Vorsatz und Arglist.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">7.2.</span>
                <div className="flex-1">
                  Bei kostenpflichtigen Diensten haftet YN Digital für entstehende Schäden lediglich, soweit diese auf einer Verletzung einer wesentlichen Vertragspflicht oder auf einem vorsätzlichen oder grob fahrlässigen Verhalten beruhen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">7.3.</span>
                <div className="flex-1">
                  Verletzt YN Digital eine wesentliche Vertragspflicht leicht fahrlässig, so ist die Haftung auf den vorhersehbaren vertragstypischen Schaden begrenzt. Eine wesentliche Vertragspflicht ist bei Verpflichtungen gegeben, deren Erfüllung die ordnungsgemäße Nutzung der Leistungen auf der Plattform erst ermöglicht oder auf deren Einhaltung der Kunde vertraut hat und vertrauen durfte.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">7.4.</span>
                <div className="flex-1">
                  Eine darüber hinausgehende Haftung von YN Digital auf Schadensersatz – mit Ausnahme der untenstehenden Regelungen in Ziffer 7.5-7.7 – ist ausgeschlossen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">7.5.</span>
                <div className="flex-1">
                  YN Digital haftet unbeschränkt bei einer Verletzung von Leben, Körper oder Gesundheit sowie im Umfang einer von YN Digital übernommenen Garantie. Dies gilt auch für die zwingende Haftung nach dem Produkthaftungsgesetz.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">7.6.</span>
                <div className="flex-1">
                  YN Digital haftet nicht für Leistungsausfälle oder Verzögerungen auf Grund höherer Gewalt, einschließlich Naturkatastrophen, behördlicher Anordnungen oder technischer Störungen außerhalb des Einflussbereichs von YN Digital.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">7.7.</span>
                <div className="flex-1">
                  Die vorstehend genannten Haftungsbeschränkungen gelten auch zugunsten der gesetzlichen Vertreter, Beschäftigten und sonstigen Erfüllungsgehilfen von YN Digital.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">8. Datenverarbeitung und Datenschutz</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">8.1.</span>
                <div className="flex-1">
                  YN Digital verarbeitet die bei der Registrierung angegebenen Informationen, um den persönlichen Account zu erstellen und für den Kunden dauerhaft zugänglich machen. Die Daten ermöglichen insbesondere, dass YN Digital mit dem Kunden kommunizieren und die vertraglichen Vereinbarungen durchsetzen kann.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">8.2.</span>
                <div className="flex-1">
                  Weitere Hinweise zum Datenschutz entnehmen Sie bitte unserer Datenschutzerklärung.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">9. Beendigung des Zugangs zum Account</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">9.1.</span>
                <div className="flex-1">
                  Der Kunde kann seinen Account jederzeit löschen. Durch die Löschung endet auch der Zugang zum Account und darin gespeicherten Daten. Die Löschung berührt nicht entstandene Zahlungsverpflichtungen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">9.2.</span>
                <div className="flex-1">
                  YN Digital behält sich das Recht vor, den Zugang des Kunden zu seinem Account zu sperren, wenn ein Kunde einer fälligen Zahlungspflicht nach schriftlicher Androhung der Sperrung nicht nachkommt. Wenn der Kunde nach der Sperrung sämtliche fällige Zahlungspflichten erfüllt, hebt YN Digital die Sperrung des Accounts wieder auf. Die Sperrung berührt nicht entstandene Zahlungsverpflichtungen.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8" id="widerrufsrecht">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">10. Widerrufsrecht</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">10.1.</span>
                <div className="flex-1">
                  Verbraucher haben bei Abschluss eines Fernabsatzgeschäfts ein gesetzliches Widerrufsrecht, über das der Anbieter nach Maßgabe des gesetzlichen Musters nachfolgend informiert.
                  <br /><br />
                  <div className="border-2 border-black p-4 mb-4">
                    <p><em>Widerrufsbelehrung</em></p><br />
                    <p><strong>Widerrufsrecht</strong><br />
                      Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.<br />
                      Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.<br />
                      Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (YN Digital GmbH, Am Schulhof 23, 28865 Lilienthal, E-Mail: info@adressfinder.org, Telefonnummer: +49 40 65725899) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.<br />
                      Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
                    </p><br />
                    <p><strong>Folgen des Widerrufs</strong><br /><br />
                      Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
                    </p>
                  </div>
                  <br />
                  <p><strong>Muster-Widerrufsformular</strong></p><br />
                  <div className="border-2 border-black p-4 mb-4">
                    <p><strong>Muster-Widerrufsformular</strong><br />
                      (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)<br /><br />
                      An YN Digital GmbH, Am Schulhof 23, 28865 Lilienthal, E-Mail: info@adressfinder.org:<br />
                      — Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*),<br />
                      — Bestellt am (*)/erhalten am (*),<br />
                      — Name des/der Verbraucher(s),<br />
                      — Anschrift des/der Verbraucher(s),<br />
                      — Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier),<br />
                      — Datum.<br />
                      (*) Unzutreffendes streichen
                    </p>
                  </div>
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">10.2.</span>
                <div className="flex-1">
                  <strong>Besondere Hinweise</strong><br />
                  Das Widerrufsrecht erlischt vorzeitig, wenn wir auf Ihre ausdrückliche Anforderung hin noch vor Ablauf der Widerrufsfrist mit der Ausführung der Dienstleistung beginnen und die Dienstleistung vollständig erbracht ist. Bei unseren Services bedeutet dies insbesondere, dass Ihr Widerrufsrecht erlischt, sobald wir in Ihrem Auftrag eine Anfrage an das zuständige Melderegister gestellt haben.
                </div>
              </li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">11. Schlussbestimmungen</h2>
            <ol className="list-none pl-6 space-y-3">
              <li className="flex">
                <span className="font-medium mr-2">11.1.</span>
                <div className="flex-1">
                  YN Digital ist nicht bereit oder verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">11.2.</span>
                <div className="flex-1">
                  Auf Verträge zwischen YN Digital und den Kunden findet das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts Anwendung. Die gesetzlichen Vorschriften zur Beschränkung der Rechtswahl und zur Anwendbarkeit zwingender Vorschriften insbesondere des Staates, in dem der Kunde als Verbraucher seinen gewöhnlichen Aufenthalt hat, bleiben unberührt.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">11.3.</span>
                <div className="flex-1">
                  Sofern es sich beim Kunden um einen Kaufmann, eine juristische Person des öffentlichen Rechts oder um ein öffentlich-rechtliches Sondervermögen handelt, ist Gerichtsstand für alle Streitigkeiten aus Vertragsverhältnissen zwischen dem Kunden und YN Digital der Sitz von YN Digital.
                </div>
              </li>
              <li className="flex">
                <span className="font-medium mr-2">11.4.</span>
                <div className="flex-1">
                  Der Vertrag bleibt auch bei rechtlicher Unwirksamkeit einzelner Punkte in seinen übrigen Teilen verbindlich. Anstelle der unwirksamen Punkte treten, soweit vorhanden, die gesetzlichen Vorschriften. Soweit dies für eine Vertragspartei eine unzumutbare Härte darstellen würde, wird der Vertrag jedoch im Ganzen unwirksam.
                </div>
              </li>
            </ol>
          </section>

          <div className="mt-8">
            <Link to="/" className="text-blue-600 hover:underline">Zurück zur Startseite</Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AGB; 